import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '../../../components/generics/PageLayout';
import { hasPemissions } from '../../../commons/utils/helpers';
import { TableContratos } from './components/TableContratos';
import { BannerInfoContratos } from './components/BannerInfoContratos';

export const Contratos = () => {
  const navigate = useNavigate();
  const [canCreate, setCanCreate] = useState(false);

  const checkCanCreate = async () => {
    const havePermissions = await hasPemissions(
      'modulo.thumano',
      'modulo.empleado.contratos',
      'create'
    );

    setCanCreate(havePermissions);
  };

  useEffect(() => {
    checkCanCreate();
  }, []);

  const handleOpenCreate = () => {
    navigate('/talento-humano/contratos/crear');
  };

  return (
    <PageLayout
      title="Gestión de Contratos"
      mainModule="Talento Humano"
      icon={'DescriptionOutlined'}
      infoAlert="Administra los modelos y plantillas de contratos para los empleados."
      actionButtons={
        <>
          {canCreate && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenCreate}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)',
              }}
            >
              Crear Contrato
            </Button>
          )}
        </>
      }
    >
      <TableContratos />

      <BannerInfoContratos />
    </PageLayout>
  );
};
